// removed by extract-text-webpack-plugin
module.exports = {"TagList":"_30d55ZxqrdTJ-OIYx5qBeM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TagList/TagList.css
// module id = 384
// module chunks = 8